import { useRef, useContext, useEffect, useState } from 'react';

import styles from './PreviewVideoFileComponent.module.css'

import { GlobalContext } from '../../../contexts/globalContext';

import CustomMultitouchComponent from '../../../files/CustomMultitouchComponent';
import VideoComponent from '../../../files/VideoComponent'

import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';

const PreviewVideoFileComponent = ({ file, setTopicFilesOpened }) => {

    const { appWidth, appHeight } = useContext(GlobalContext);

    const ref = useRef(null);
    const mtRef = useRef(null);
    const videoRef = useRef(null);
    const imageAspectRatioRef = useRef(null);
    const isOpenCanvasRef = useRef(false);

    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [baseSize, setBaseSize] = useState({ w: 0, h: 0 });

    const startingHeight = 600;

    const options = {
        appWidth,
        appHeight,
        maxScale: appHeight / startingHeight,
        minScale: 0.5
    }

    const containerStyle = {
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
    };

    useEffect(() => {
        mtRef.current.style.zIndex = GetMaxZIndex() + 1;
    }, []);

    const onMinScaleReached = () => {
        setTopicFilesOpened(files => files.filter(a => a.uid !== file.uid));
    }

    return (
        <CustomMultitouchComponent ref={mtRef} dragGesture={false} x={file.x + 75} y={file.y + 40} width="auto" height="auto" onMinScaleReached={onMinScaleReached} options={options}
            dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: appWidth, height: 400 }} isOpenCanvasRef={isOpenCanvasRef}>
            <div className={styles.touch_component} ref={ref} style={containerStyle}>
                <VideoComponent name={file.name} ref={videoRef} path={process.env.REACT_APP_CMS_URL + file.path} width={width} setWidth={setWidth} height={height} setHeight={setHeight}
                    imageAspectRatioRef={imageAspectRatioRef} setBaseSize={setBaseSize} setTopicFilesOpened={setTopicFilesOpened} file={file}/>
            </div>
        </CustomMultitouchComponent>
    );

}

export default PreviewVideoFileComponent;